export const PROD_OPENSEA_WALLET_URL = "https://wallet.opensea.io"

export const DEV_OPENSEA_WALLET_URL =
  "https://privy-embedded-wallet-app-prod.preview.dev.privatesea.io"

export const LOCAL_OPENSEA_WALLET_URL = "http://localhost:5173"
